// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"bcb2647d003694a2ddc0","404":"8ca33231cf37b45f368b","406":"1c7af70fb8ed61cd81ab"}[chunkId] + ".css";
};